import React from "react";
import { Button } from "@mui/material";

import "./style.css";

const NotificationBanner = ({ title, onClick, style, btnLabel }: Props) => {
  return (
    <div className="wbr-component-banner" style={style}>
      <div className="wbr-component-banner-inner">
        <div className="wbr-component-banner-text">{title}</div>
        <Button size="small" className="wbr-component-banner-button" onClick={onClick}>
          {btnLabel}
        </Button>
      </div>
    </div>
  );
};

export interface Props {
  title: string;
  onClick: () => void;
  btnLabel: string;
  style?: any;
}

export default NotificationBanner;
